import filter from 'lodash-es/filter';
import memoize from 'lodash-es/memoize';
import { CategoriesSelector } from 'module/Redux/Categories';
import { Post } from 'module/Model/Post';
import { PostList, PostListItem } from 'module/Model/PostList';
import { PostSelector } from 'module/Redux/Post';
import { Route, RouteType } from 'module/Model/Routes';
import { RouterSelector } from 'module/Redux/Router';
import { se } from 'module/Common';
import { State } from '../index';
import { Wish } from 'module/Model/Wish';

export namespace PostListSelector {
  export const select = (s: State) => se(s, 'postList', s.postList);

  const selectForRoute = (s: State, route: Route) => {
    const postsWish = select(s);
    const categoryWish = CategoriesSelector.selectForRoute(s, route);
    if (route && route.type === RouteType.Category) {
      return Wish.combine([postsWish, categoryWish], (posts, category) => {
        const catId = category.id;
        return filter(posts, post => {
          return PostListItem.hasCategoryId(post, catId);
        });
      });
    }
    return postsWish;
  };

  export const selectForMatchingRoute = (s: State) => selectForRoute(s, RouterSelector.selectMatchingRoute(s));

  const allPostsExceptUncached = (postsWish: Wish<PostList>, currentPostWish: Wish<Post>): Wish<PostList> => {
    return Wish.combine([postsWish, currentPostWish], (posts, currentPost) => {
      return filter(posts, post => {
        return PostListItem.getId(post) !== Post.getId(currentPost);
      });
    });
  };

  const allPostsExcept = memoize(allPostsExceptUncached);

  export const selectNextPosts = (s: State) => {
    const currentPostWish = PostSelector.selectCurrent(s);
    const postsWish = selectForRoute(s, RouterSelector.selectLastGridRouteOrHome(s));
    return allPostsExcept(postsWish, currentPostWish);
  };
}



// WEBPACK FOOTER //
// ./src/module/Redux/PostList/PostListSelector.ts